var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
export var useTrackCountMap = function (tracks) {
    return React.useMemo(function () {
        return tracks.reduce(function (acc, track) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[track.id] = track.id in acc ? acc[track.id] + 1 : 1, _a)));
        }, {});
    }, [tracks]);
};
